// src/pages/EducationYearTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiTrash2 } from "react-icons/fi";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify"; 
import "react-confirm-alert/src/react-confirm-alert.css";

const EducationYearTable = () => {
  const [rows, setRows] = useState([]);

  const fetchData = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/education-years/list`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
      );
      setRows(data);
    } catch (err) {
      console.error("❌ EducationYear listelenemedi:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Silme işlemi
const handleDelete = (id) => {
  confirmAlert({
    title: "Kaydı Sil",
    message: "Bu kaydı silmek istediğinize emin misiniz?",
    buttons: [
      {
        label: "Evet, sil",
        onClick: async () => {
          try {
            await axios.delete(
              `${process.env.REACT_APP_API_BASE_URL}/api/education-years/${id}`,
              { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
            );
            toast.success("Kayıt silindi.");
            fetchData();
          } catch (err) {
            console.error("❌ Silme hatası:", err);
            toast.error("Silme işlemi başarısız oldu.");
          }
        },
      },
      {
        label: "İptal",
        onClick: () => {} // iptal tuşuna basıldığında bir şey yapma
      }
    ]
  });
};

  const columns = useMemo(() => [
    { accessorKey: "id",    header: "ID",    size: 50 },
    { accessorKey: "title", header: "Başlık"      },
    {
      accessorKey: "actions",
      header:        "İşlemler",
      
      enableSorting: false,
      cell:          info => {
        const id = info.row.original.id;
         return (
       <div className="d-flex justify-content-end">
         <button
           onClick={() => handleDelete(id)}
           className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
           title="Sil"
         >
           <FiTrash2 />
         </button>
       </div>
     );
      
    }
  }    
  ], []);

  return <Table data={rows} columns={columns} />;
};

export default EducationYearTable;
